import { defineComponent as _defineComponent } from 'vue'
import XSolidIcon from '@/assets/img/XSolidIcon.svg'
import ChevronRightSolidIcon from '@/assets/img/ChevronRightSolidIcon.svg'
import ChevronLeftSolidIcon from '@/assets/img/ChevronLeftSolidIcon.svg'
import { computed, ref } from '@nuxtjs/composition-api'
import { useNuxtListeners } from '~/lib/composables/useNuxtListeners'


export default /*#__PURE__*/_defineComponent({
  __name: 'FullscreenLightbox',
  setup(__props) {

const isOpen = ref(false)
const touchStartEvent = ref<TouchEvent | null>(null)
const imageUrls = ref<Array<string>>([])
const currentIdx = ref(0)
const currentUrl = computed(() => imageUrls.value[currentIdx.value])
const imgClasses = ref('')
useNuxtListeners({
  'show-fullscreen-gallery': (urls, classes) => {
    isOpen.value = true
    imageUrls.value = urls
    currentIdx.value = 0
    imgClasses.value = classes ?? ''
  },
})

function closeLightbox() {
  isOpen.value = false
  imageUrls.value = []
}
function nextImage() {
  currentIdx.value = (currentIdx.value + 1) % imageUrls.value.length
}

function previousImage() {
  if (currentIdx.value > 0) {
    currentIdx.value = currentIdx.value - 1
  } else {
    currentIdx.value = imageUrls.value.length - 1
  }
}

function detectTouchStart(event: TouchEvent) {
  touchStartEvent.value = event
}

function detectTouchEnd(event: TouchEvent) {
  if (touchStartEvent.value == null) {
    return
  }
  if (touchStartEvent.value.changedTouches[0].screenX < event.changedTouches[0].screenX) {
    nextImage()
  }
  if (touchStartEvent.value.changedTouches[0].screenX > event.changedTouches[0].screenX) {
    previousImage()
  }
}

return { __sfc: true,isOpen, touchStartEvent, imageUrls, currentIdx, currentUrl, imgClasses, closeLightbox, nextImage, previousImage, detectTouchStart, detectTouchEnd, XSolidIcon, ChevronRightSolidIcon, ChevronLeftSolidIcon }
}

})